import {createGlobalStyle} from "styled-components";

export const GlobalStyles = createGlobalStyle`

    @font-face {
        font-family: 'Jaldi';
        src: url('${props => props.theme.assets.fonts.Jaldi_Bold_eot.toString()}');
        src:  url('${props => props.theme.assets.fonts.Jaldi_Bold_woff.toString()}') format('woff'),
                url('${props => props.theme.assets.fonts.Jaldi_Bold_ttf.toString()}') format('truetype');
        font-weight: bold;
        font-style: normal;
    } 

    @font-face {
        font-family: 'Jaldi';
        src: url('${props => props.theme.assets.fonts.Jaldi_Regular_eot.toString()}');
        src:  url('${props => props.theme.assets.fonts.Jaldi_Regular_woff.toString()}') format('woff'),
                url('${props => props.theme.assets.fonts.Jaldi_Regular_ttf.toString()}') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    body {
        font-weight: ${props => props.theme.fontWeight.normal};
        font-family: 'Jaldi', sans-serif;
    }

`
